import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "input-text" }
const _hoisted_2 = { class: "p-2" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "p-2" }
const _hoisted_5 = { class: "m-0 p-0" }
const _hoisted_6 = {
  key: 0,
  class: "small m-0 ml-1 p-0"
}
const _hoisted_7 = {
  key: 1,
  class: "small m-0 ml-1 p-0 d-flex w-100"
}
const _hoisted_8 = { class: "border border-info px-2 py-1 small mx-2 rounded button-template" }
const _hoisted_9 = {
  key: 2,
  class: "small m-0 ml-1 p-0"
}

import { TemplateModule } from "@/store/modules/Template";
import { Template, TemplateStatus } from "@/types/templates";
import { computed, ref, watch, watchEffect } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    templates: null,
    activeScrollbar: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	templates?: Template[];
	activeScrollbar?: boolean;
}


const currentLanguage = ref("");
const template = computed<Template | undefined>(() =>
	props.templates?.find(t => t.language === currentLanguage.value)
);
function getStatus(status: TemplateStatus) {
	return (
		{
			approved: "success",
			rejected: "",
		} as { [key in TemplateStatus]: string }
	)[status];
}
function changeLanguage(language: string) {
	TemplateModule.setFilter({ language });
	currentLanguage.value = language;
}
watch(
	() => TemplateModule.filters.actual,
	() => {
		if (TemplateModule.filters.actual === template.value?.name)
			TemplateModule.filters.language = currentLanguage.value;
	}
);
watchEffect(() => {
	currentLanguage.value =
		props.templates?.find(t => /(es|es_mx|es_ar|en)/i.test(t.language))
			?.language ??
		props.templates?.[0].language ??
		"";
});
function setActive() {
	if (!props.activeScrollbar)
		TemplateModule.setFilter({
			actual: template.value?.name,
			language: currentLanguage.value,
		});
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_col = _resolveComponent("el-col")!

  return (_openBlock(), _createBlock(_component_el_col, {
    class: _normalizeClass(["fs-base px-3 py-2 template-item border rounded w-100 my-2", {
			'max-height': __props.activeScrollbar,
			'can-hover': !__props.activeScrollbar,
			selected:
				!__props.activeScrollbar && _unref(TemplateModule).filters.actual === _unref(template)?.name,
		}]),
    onClick: setActive
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(__props.activeScrollbar ? 'el-scrollbar' : 'div'), {
        height: __props.activeScrollbar ? '140px' : 'auto'
      }, {
        default: _withCtx(() => [
          (_unref(template))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(template).name), 1),
                _createVNode(_component_el_tag, {
                  class: "ml-2",
                  type: "info"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("small", null, _toDisplayString(_unref(template).category), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tag, {
                  class: "ml-2",
                  type: getStatus(_unref(template).status)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("small", null, _toDisplayString(_unref(template).status), 1)
                  ]),
                  _: 1
                }, 8, ["type"]),
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.templates, (temp) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass(["btn btn-sm rounded-pill", 
							temp.language === currentLanguage.value
								? 'btn-primary'
								: 'btn-secondary'
						]),
                      key: temp.language,
                      onClick: ($event: any) => (changeLanguage(temp.language))
                    }, [
                      _createElementVNode("small", null, _toDisplayString(temp.language), 1)
                    ], 10, _hoisted_3))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(template).components, (component) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: component.type,
                      class: "d-flex py-1 align-items-center"
                    }, [
                      _createElementVNode("h6", _hoisted_5, _toDisplayString(component.type), 1),
                      (component.type === 'HEADER')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(component.format !== "TEXT"
										? `Se necesita subir un ${component.format}`
										: component.text), 1))
                        : (component.type === 'BUTTONS')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.buttons, (btn) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: btn.text
                                }, [
                                  _createElementVNode("div", _hoisted_8, _toDisplayString(btn.text), 1)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(component.text), 1))
                    ]))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["height"]))
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})